import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import Navigation from './components/Navigation';
import { CursorRing, ScrollProgress } from './components/PageChrome';
import Portfolio from './pages/Portfolio';

function App() {
  return (
    <Router>
      <MotionConfig reducedMotion="user">
        <a
          href="#main"
          className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[90] focus:rounded-full focus:bg-azure focus:px-5 focus:py-3 focus:text-sm focus:font-medium focus:text-night"
        >
          Skip to content
        </a>
        <ScrollProgress />
        <CursorRing />
        <Navigation />
        <Routes>
          <Route path="/" element={<Portfolio />} />
        </Routes>
      </MotionConfig>
    </Router>
  );
}

export default App;
